export const careerGoalAndRoleTrackingLinkName = (goal?: boolean, role?: boolean) => {
  if (!goal && !role) {
    return 'no_onboarding_data';
  } else if (goal && !role) {
    return 'partial_onboarding_data_learning_goal';
  } else if (!goal && role) {
    return 'partial_onboarding_data_roles';
  } else {
    return 'completed_onboarding_data';
  }
};
